export default __webpack_public_path__ + "static/media/PinClip.a053fc6c.png";